<template>
  <div class="q-page">
    <div class="container py-5">

      <!-- Breadcrumb -->
      <nav aria-label="breadcrumb" class="mb-4">
        <ol class="breadcrumb q-breadcrumb">
          <li class="breadcrumb-item"><router-link :to="{ name: 'Home' }">Inicio</router-link></li>
          <li class="breadcrumb-item active">Nosotros</li>
        </ol>
      </nav>

      <p class="q-section-title">Sobre nosotros</p>

      <!-- Hero image -->
      <div v-if="imgSrcs && imgSrcs.aboutUs" class="q-about-hero mb-5">
        <img :src="imgSrcs.aboutUs" alt="Sobre nosotros" class="q-about-img" />
      </div>

      <!-- Text content -->
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <p class="q-about-text pre-formatted">{{ textAboutUs }}</p>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      imgSrcs:       "ecommerce/imgSrcs",
      configuration: "ecommerce/configuration",
    }),
    textAboutUs() {
      return this.configuration.fillers && this.configuration.fillers.aboutus;
    },
  },
};
</script>

<style scoped>
.q-about-hero {
  width: 100%;
  border-radius: var(--q-radius-lg);
  overflow: hidden;
  border: 1px solid var(--q-border);
}
.q-about-img {
  width: 100%;
  max-height: 340px;
  object-fit: cover;
  display: block;
}
.q-about-text {
  font-size: 14px;
  line-height: 1.8;
  color: var(--q-text-muted);
  white-space: pre-line;
}
.q-breadcrumb { background: transparent; padding: 0; margin: 0; }
.q-breadcrumb .breadcrumb-item { font-size: 14px; color: var(--q-text-subtle); }
.q-breadcrumb .breadcrumb-item a { color: var(--q-text-muted); }
.q-breadcrumb .breadcrumb-item a:hover { color: var(--primary-color); }
.q-breadcrumb .breadcrumb-item + .breadcrumb-item::before { color: var(--q-text-subtle); }
</style>
